import React, {memo} from 'react';
import {useHistory} from 'react-router-dom';
import {Box} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles';
import {LinkArrowIcon} from '@epic-ui/icons';
import {Button} from '@epic-ui/components';
import {generateRoutePath} from '@epic-core/common';

import useLocalization from '../../hooks/useLocalization';
import RewardsWidget from '../../components/v2/sections/fortnite-games/rewards/RewardsWidget';
import useGamesData from './useGamesData';
import {SidebarContainer} from '../../components';
import RewardsTop10GamesPanel from '../../components/v2/sections/fortnite-games/rewards/RewardsTop10GamesPanel';

import {WidgetsContainer} from './FortniteGames.styles';

const CODES = {
    link: 'epic.affiliate.fortnite_games.rewards.link'
};

const Rewards = () => {
    const getMessage = useLocalization();
    const theme = useTheme();
    const history = useHistory();

    const {
        data: {codeNamesMap, recentGamesOptions},
        loading: gamesLoading
    } = useGamesData();

    const handleClick = () => {
        history.push(generateRoutePath('payout'));
    };

    return (
        <WidgetsContainer>
            <Box width="100%">
                <Box minHeight="648px">
                    <RewardsWidget
                        gamesList={recentGamesOptions}
                        keysMap={codeNamesMap}
                        gamesLoading={gamesLoading}
                    />
                </Box>
                <Box display="flex" justifyContent="flex-end" mt={5}>
                    <Button
                        style={{
                            fontSize: '0.875rem',
                            textTransform: 'none',
                            color: theme.palette.text.secondary,
                            border: `1px solid ${theme.palette.action.active}`
                        }}
                        underline="none"
                        color="secondary"
                        endIcon={<LinkArrowIcon />}
                        variant="outlined"
                        onClick={handleClick}>
                        {getMessage(CODES.link)}
                    </Button>
                </Box>
            </Box>
            <SidebarContainer>
                <RewardsTop10GamesPanel keysMap={codeNamesMap} gamesLoading={gamesLoading} />
            </SidebarContainer>
        </WidgetsContainer>
    );
};

export default memo(Rewards);
